import React from 'react'
import PropTypes from 'prop-types'
import { observer } from 'mobx-react'
import 'react-datepicker/dist/react-datepicker.css'
import { useValue } from '@morningtrain/react-resources'
import { Env } from '@morningtrain/helpers'
import EmployeeCategoryFilter from 'support/filters/EmployeeCategoryFilter'

export default function EmploymentCategoryFilterSyncedWithModel ({ name, ...forwardProps }) {
  const category = useValue('category', Env.get('page.filters.category.defaultValue'))

  return <EmployeeCategoryFilter name={name} defaultValue={category} {...forwardProps} />
}

EmploymentCategoryFilterSyncedWithModel.propTypes = {
  name: PropTypes.string.isRequired
}
